<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-6"
        :placeholder="$t('name')"
        :label="$t('name')"
        help="Este es el nombre del Widget con el que se mostrará en los listados"
        :v="$v.value.name"
        v-model="value.name"
      />
      <LmTextInput
        class="col-6"
        :placeholder="$t('title')"
        :label="$t('title')"
        help="Este es el título del gráfico"
        :v="$v.value.title"
        v-model="value.title"
      />
    </b-row>
    <b-row>
      <LmTreeSelect
        class="col-12"
        label="Calcular"
        :options="calculateOptions"
        :v="$v.value.calculate"
        v-model="value.calculate"
        @input="onCalculateChange"
      />
      <LmTreeSelect
        class="col-12"
        label="Origen de datos"
        :pathToGetOptions="sourcePath"
        :v="$v.value.dataOrigin"
        v-model="value.dataOrigin"
      />
      <b-container>
        <b-row>
          <div class="col-12">
            <label
              title="Icono"
              class="text-truncate"
            >
              Icono
            </label>
            <font-awesome-icon
              id="font-awesome-icon-edit"
              icon="edit"
              size="sm"
              class="clickable float-right mt-1"
              :class="{ 'ml-2': help }"
              v-if="showEditButton"
              @click="$emit('edit-button-clicked')"
              />
            <font-awesome-icon
              icon="question-circle"
              size="sm"
              class="clickable float-right mt-1"
              v-b-tooltip.hover="'Este es el icono del contador'"
            />
          </div>
          <div class="col-1 pt-1">
            <i class="icon mdi" :class="`mdi-${value.icon}`"/>
          </div>
          <treeselect
            v-model="icon"
            :multiple="false"
            :options="iconsOptions"
            valueFormat="object"
            :normalizer="normalizer"
            class="col-11"
          >
            <label slot="option-label" slot-scope="{ node, labelClassName }" class="col-12" :class="labelClassName">
              <i class="icon mdi" :class="`mdi-${node.label}`"/>
              {{ node.label }}
            </label>
          </treeselect>
        </b-row>
      </b-container>
      <LmCheckbox
        class="col-12"
        :title="$t('available_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_in')"
        type="multiple"
        :options="availableInOptions"
        v-model="value.availableIn"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required } from 'vuelidate/lib/validators'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import Treeselect from '@lumile/vue-treeselect'

export default {
  components: {
    LmTextInput,
    LmCheckbox,
    LmTreeSelect,
    Treeselect
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      normalizer (node) {
        return {
          id: node.id,
          label: node.id
        }
      },
      iconsOptions: [
        { id: 'alert-plus' },
        { id: 'account' },
        { id: 'alert' },
        { id: 'archive' },
        { id: 'attachment' },
        { id: 'bell' },
        { id: 'book' },
        { id: 'calendar' },
        { id: 'camera' },
        { id: 'chart-bar' },
        { id: 'check' },
        { id: 'clock' },
        { id: 'cog' },
        { id: 'comment' },
        { id: 'delete' },
        { id: 'email' },
        { id: 'file' },
        { id: 'folder' },
        { id: 'heart' },
        { id: 'home' },
        { id: 'information' },
        { id: 'magnify' },
        { id: 'map-marker' },
        { id: 'pencil' },
        { id: 'phone' },
        { id: 'plus' },
        { id: 'printer' },
        { id: 'refresh' },
        { id: 'star' },
        { id: 'tag' },
        { id: 'upload' }
      ],
      icon: null,
      availableInOptions: [
        {
          text: 'Bandeja de Entradas',
          value: 'inbox'
        },
        {
          text: 'Dashboard',
          value: 'dashboard'
        },
        {
          text: 'Reportes',
          value: 'report'
        }
      ],
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ],
      calculateOptions: [
        {
          id: 'count',
          name: 'Cantidad'
        },
        {
          id: 'average',
          name: 'Tiempo promedio',
          sources: ['documents']
        },
        {
          id: 'max',
          name: 'Tiempo máximo',
          sources: ['documents']
        },
        {
          id: 'min',
          name: 'Tiempo mínimo',
          sources: ['documents']
        },
        {
          id: 'trees_saved',
          name: 'Árboles salvados',
          sources: ['documents']
        },
        {
          id: 'water_saved',
          name: 'Agua ahorrada',
          sources: ['documents']
        },
        {
          id: 'reams_saved',
          name: 'Resmas ahorradas',
          sources: ['documents']
        }
      ],
      sourcePath: '/datatables/all'
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      title: {
        required
      },
      dataOrigin: {
        required
      }
    }
  },
  watch: {
    icon: {
      handler (val) {
        this.value.icon = val?.id || ''
      }
    }
  },
  methods: {
    onCalculateChange (event) {
      let params = ''
      if (event?.sources) {
        const source = event.sources.join(',')
        params = '?source=' + source
      }
      this.sourcePath = '/datatables/all' + params
      this.value.dataOrigin = null
    }
  },
  async created () {
    this.$nextTick(() => {
      this.value.calculate = {
        id: 'count',
        name: 'Cantidad'
      }
    })
  }
}
</script>
